import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@ncoder/ui';
import { TestCategoryItem } from '../../atoms/testing/TestCategoryItem';

interface TestCategory {
  id: string;
  label: string;
  status: 'passed' | 'needs-work';
}

interface TestCategoriesPanelProps {
  categories: TestCategory[];
}

export const TestCategoriesPanel: React.FC<TestCategoriesPanelProps> = ({
  categories,
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Test Categories</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        {categories.map((category) => (
          <TestCategoryItem
            key={category.id}
            label={category.label}
            status={category.status}
          />
        ))}
      </CardContent>
    </Card>
  );
};
